import { Link, useParams } from 'react-router-dom';

/**
 * @file Stub — each level ships a `gallery.js` that lays its archetypes out
 * on a neutral plane for isolated review (buildings, trees, creatures). Wave
 * C/D wire this route up to it via `GameCanvas` + that module's own
 * `buildLevel`; until then this is a styled placeholder, not a dead end.
 */
export default function GalleryRoute() {
  const { levelId } = useParams();

  return (
    <div className="flex h-full w-full flex-col items-center justify-center gap-4 bg-[#0a0a0f] px-6 text-center text-[#d8dae6]">
      <span className="text-[10px] uppercase tracking-widest text-[#6f7488]">gallery</span>
      <h1 className="text-2xl font-semibold">{levelId}</h1>
      <p className="max-w-md text-sm text-[#8a8fa3]">
        Each level ships a <code className="rounded bg-[#12121a] px-1 py-0.5">gallery.js</code> that lays its
        archetypes out on a neutral plane — the mandatory review tool for buildings, trees, and creatures. Wave C/D
        wire this route up to it.
      </p>
      <Link
        to="/"
        onMouseDown={(e) => e.preventDefault()}
        className="mt-2 rounded-md border border-[#22222e] px-3 py-2 text-sm hover:border-[#3a3a52]"
      >
        back to menu
      </Link>
    </div>
  );
}
